export default __webpack_public_path__ + "static/media/Mickey-Balloons.d7cebd8c.jpg";